export const formatTo12Hour = (timeStr) => {
    if(timeStr && timeStr.length>0){
        const [hour, minute] = timeStr.split(':');
        const h = parseInt(hour);
        const ampm = h >= 12 ? 'PM' : 'AM';
        const hour12 = h % 12 === 0 ? 12 : h % 12;
        return `${hour12}:${minute} ${ampm}`;
    }else{
        return 'n/a';
    }
};


export const getCurrentDateInISOFormat =()=>{
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    //formattedDate -  Outputs: "2025-05-01"
    return formattedDate;
}


 export const parseTimeStringToDate = (timeString) => {
  const date = new Date();
  if (timeString && timeString.includes(':')) {
    const [hours, minutes] = timeString.split(':').map(Number);
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
  }
  return date;
};

 
export  const parseDate = (dateString) => {
    if (!dateString) return null;
    
    try {
      // Try direct parsing first
      let date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        return date;
      }
      
      // Try parsing common date formats
      const formats = [
        // DD/MM/YYYY
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
        // DD-MM-YYYY
        /^(\d{1,2})-(\d{1,2})-(\d{4})$/,
        // YYYY-MM-DD
        /^(\d{4})-(\d{1,2})-(\d{1,2})$/,
        // YYYY/MM/DD
        /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/
      ];
      
      for (let format of formats) {
        const match = dateString.match(format);
        if (match) {
          let year, month, day;
          
          if (format.source.startsWith('^(\\d{4})')) {
            // YYYY-MM-DD or YYYY/MM/DD format
            year = parseInt(match[1]);
            month = parseInt(match[2]) - 1; 
            day = parseInt(match[3]);
          } else {
            // DD/MM/YYYY or DD-MM-YYYY format
            day = parseInt(match[1]);
            month = parseInt(match[2]) - 1; 
            year = parseInt(match[3]);
          }
          
          date = new Date(year, month, day);
          if (!isNaN(date.getTime())) {
            return date;
          }
        }
      }
      
      return null;
    } catch (error) {
    
      return null;
    }
  };


export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU');
  };


export const roundToNearest5Minutes = (date) => {
const ms = 1000 * 60 * 5;
return new Date(Math.round(date.getTime() / ms) * ms);
};



export const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};


export const getReminderDate = (selectedDateStr, daysBefore = 1) => {
    const selectedDate = new Date(selectedDateStr);
    selectedDate.setDate(selectedDate.getDate() - daysBefore);
  
    const year = selectedDate.getFullYear();
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = selectedDate.getDate().toString().padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };

export const convertTo24Hour = (time, amPm) => {
    let [hour, minute] = time.split(':').map(Number);
  
    if (amPm === 'PM' && hour < 12) {
      hour += 12;
    } else if (amPm === 'AM' && hour === 12) {
      hour = 0; 
    }
  
    return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
};

 export const formatDateLongDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

